import {combineReducers} from "redux"
import {cartReducer} from "./cartReducer"
import {trackingReducer} from "./trackingReducer"

export const rootReducer = combineReducers({
    cart: cartReducer,
    trackingVersion: trackingReducer
})

